import { cn } from '@/lib/utils';
import { ComponentProps } from 'react';

import FonMarkSvg from '@/assets/fon-mark.svg?react';

type Props = Omit<ComponentProps<'svg'>, 'aria-label'> & {
  alt?: string;
};

export default function FonMark({
  alt = 'FONGPT',
  className,
  ...props
}: Props) {
  return (
    <FonMarkSvg
      {...props}
      aria-hidden={alt ? undefined : true}
      aria-label={alt || undefined}
      role={alt ? 'img' : undefined}
      className={cn('object-contain', className)}
    />
  );
}
